import styled from 'styled-components';

const ModalContainerStyled = styled.div`
  display: flex;
  position: absolute;
  justify-content: center;
  width: 100%;
  left: 0;
  padding: 32px 24px;
  padding-top: 60px;
  height: calc(100vh - 100px);
  z-index: 5;
  background: rgba(255, 255, 255, 0.7);
`;

const ModalStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding: 24px 40px 24px 40px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 5px 10px 0px #2d124126;
  opacity: 1;
  gap: 16px;
  min-width: 260px;
  max-height: 210px;

  strong {
    width: 100%;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
  }
`;

const PayContainerStyled = styled.div`
  display: flex;
  padding: 32px 24px;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  height: calc(100vh - 100px);
`;

const PayInfoContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  > div.warning > div {
    grid-template-columns: 16px auto;
  }
`;

const SelectorPaymentMethodStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  h1 {
    color: #0e141d;
    font-size: 18px;
    font-weight: 700;
    line-height: 20px;
  }
`;

const PayChipStyled = styled.div`
  display: flex;
  align-items: center;
  padding: 18px;
  width: 100%;
  gap: 48px;
  border-radius: 8px;
  border: 1px solid #c9cfd7;
  background: #eff1f3;
  span {
    color: #494c66;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
  }

  strong {
    color: #0e141d;
    font-size: 20px;
    font-weight: 700;
    line-height: 26px;
  }
`;

const TitleSelectorStyled = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

const ContainerRadioGroupStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const ContainerRadioButtonStyled = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid ${props => (props.checked ? '#4D008C' : '#c9cfd7')};
  width: 100%;
  & label {
    height: 20px;
    > span:nth-child(2) {
      color: #0e141d;
      font-size: 18px;
      font-weight: 700;
      line-height: 20px;
    }
  }
`;

const DisclaimerWompayStyled = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 34px;
  margin-top: 4px;
  color: #494c66;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
`;

const DisclaimerKushkiStyled = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #0e141d;
  gap: 8px;
  a {
    color: #4d008c;
    font-weight: 500;
    line-height: 20px;
    font-size: 14px;
    text-decoration-line: underline;
    text-align: center;
    margin-left: -20px;
  }
`;

const DisclaimerErrorStyled = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #0e141d;
`;

export {
  ModalContainerStyled,
  ModalStyled,
  PayContainerStyled,
  PayInfoContainerStyled,
  SelectorPaymentMethodStyled,
  PayChipStyled,
  TitleSelectorStyled,
  ContainerRadioGroupStyled,
  ContainerRadioButtonStyled,
  DisclaimerWompayStyled,
  DisclaimerKushkiStyled,
  DisclaimerErrorStyled,
};
